import React from 'react';
import { statusStyle, typeStyle, urgencyLabel, submissionStyle } from './theme';

export const StatusBadge = ({ status }) => {
  const s = statusStyle(status);
  return (
    <span
      data-testid="sr-status-badge"
      className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold whitespace-nowrap ${s.className}`}
    >
      {s.short}
    </span>
  );
};

export const TypeBadge = ({ type }) => (
  <span
    data-testid="sr-type-badge"
    className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold ${typeStyle(urgencyLabel(type))}`}
  >
    {urgencyLabel(type)}
  </span>
);

export const SubmissionBadge = ({ source }) => {
  const s = submissionStyle(source);
  return (
    <span
      data-testid="sr-origin-badge"
      className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold whitespace-nowrap ${s.className}`}
    >
      {s.label}
    </span>
  );
};
